import React from 'react';
import './ChangeDetails.css';

export interface FieldChange {
  field: string;
  label: string;
  before: string;
  after: string;
}

export function readFieldChanges(meta: Record<string, unknown> | null | undefined): FieldChange[] {
  const changes = meta?.changes;
  if (!Array.isArray(changes)) return [];
  return changes.filter((change): change is FieldChange =>
    change != null && typeof change === 'object' &&
    typeof change.field === 'string' && typeof change.label === 'string' &&
    typeof change.before === 'string' && typeof change.after === 'string'
  );
}

const ChangeDetails: React.FC<{ changes: FieldChange[] }> = ({ changes }) => (
  <div className="change-details">
    {changes.map((change) => (
      <div className="change-details-field" key={change.field}>
        <strong>{change.label}</strong>
        <div className="change-details-values">
          <div><span>Было</span><p>{change.before}</p></div>
          <div><span>Стало</span><p>{change.after}</p></div>
        </div>
      </div>
    ))}
  </div>
);

export default ChangeDetails;
